import React, { useState, useEffect } from 'react';
const SCREEN_XS = 480;
const SCREEN_SM = 576;
const SCREEN_MD = 768;
const SCREEN_LG = 992;
const SCREEN_XL = 1200;
const SCREEN_XXL = 1600;

export const DimensionsContext = React.createContext();

export const DimensionsProvider = ({ children }) => {
  const [size, setSize] = useState([0, 0]);
  useEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return (
    <DimensionsContext.Provider
      value={{
        size,
        isPhoneScreen: size[0] < SCREEN_XS,
        isTabletScreen: size[0] > SCREEN_XS - 1 && size[0] < SCREEN_MD - 1,
        isPc: size[0] > SCREEN_MD - 1,
        isPhone767: size[0] < SCREEN_MD - 1,
        isPhone576: size[0] < SCREEN_SM,
        isScreen480991: size[0] > SCREEN_XS && size[0] < SCREEN_LG - 1 ,
        isTabletBig: size[0] > SCREEN_XL - 1,
        isScreenLG: size[0] < SCREEN_LG - 1
      }}
    >
      {children}
    </DimensionsContext.Provider>
  );
};

export const useDimensions = () => React.useContext(DimensionsContext);
